import api from '../config/api'

export interface IPermission {
  id: number
  name: string
  description?: string
  created_at?: string
  updated_at?: string
}

// Fetch permissions for a single role (GET /roles/{roleId}/permissions)
const getPermissions = (roleId: number) => {
  return api.get<IPermission[]>(`/roles/${roleId}/permissions`)
}

// Sync permissions for a role (PUT /roles/{roleId}/permissions)
// Expects body: { permissions: number[] }
const syncPermissions = (roleId: number, permissions: number[]) => {
  return api.put(`/roles/${roleId}/permissions`, { permissions })
}

const RolesPermissionsService = {
  getPermissions,
  syncPermissions,
}

export default RolesPermissionsService
